/* eslint-disable */
import { useState } from "react";
import { useTheme } from "../tokens";

/** Responsive wireframe shell: drawer on mobile, icon rail on tablet, full sidebar on desktop. */
export default function ResponsiveShell({
  dark,
  viewport = "desktop",
  sidebar,
  topbar,
  footer,
  children,
  pageTitle = "Page",
  fullHeader = null,
  navOpen: navOpenProp,
  onNavToggle,
}) {
  const th = useTheme(dark);
  const mob = viewport === "mobile";
  const tablet = viewport === "tablet";
  const [navOpenInternal, setNavOpenInternal] = useState(false);
  const navOpen = navOpenProp ?? navOpenInternal;

  const toggleNav = () => {
    if (onNavToggle) onNavToggle(!navOpen);
    else setNavOpenInternal((open) => !open);
  };

  const closeNav = () => {
    if (onNavToggle) onNavToggle(false);
    else setNavOpenInternal(false);
  };

  const sidebarNode =
    typeof sidebar === "function"
      ? sidebar({ collapsed: tablet, onNavigate: mob ? closeNav : undefined })
      : sidebar;

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, minWidth: 0, height: "100%" }}>
      {fullHeader}
      {!fullHeader && mob && (
        <div
          style={{
            height: 40,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "0 12px",
            borderBottom: `1px solid ${th.border}`,
            background: th.surface,
          }}
        >
          <button
            type="button"
            onClick={toggleNav}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, color: th.textSec, padding: 4 }}
          >
            ☰
          </button>
          <span style={{ fontSize: 12, fontWeight: 500, color: th.text }}>{pageTitle}</span>
        </div>
      )}
      <div style={{ display: "flex", flex: 1, minHeight: 0, minWidth: 0, position: "relative", alignItems: "stretch" }}>
        {mob && navOpen && (
          <CardOverlay onClick={closeNav} />
        )}
        {!mob && sidebarNode}
        {mob && navOpen && (
          <div
            style={{
              width: 200,
              flexShrink: 0,
              zIndex: 30,
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              boxShadow: "4px 0 24px rgba(0,0,0,0.2)",
            }}
          >
            {sidebarNode}
          </div>
        )}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, minHeight: 0 }}>
          {!fullHeader && !mob && topbar}
          <div style={{ flex: 1, overflow: "auto", minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}>
            {children}
          </div>
        </div>
      </div>
      {footer}
    </div>
  );
}

function CardOverlay({ onClick }) {
  return (
    <div
      onClick={onClick}
      style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 20 }}
    />
  );
}
